<script>
  import { onMount } from "svelte";
  import { fly } from "svelte/transition";
  import Tailwind from "./Tailwind.svelte";
  import PDFPage from "./PDFPage.svelte";
  import Image from "./Image.svelte";
  import Text from "./Text.svelte";
  import Drawing from "./Drawing.svelte";
  import DrawingCanvas from "./DrawingCanvas.svelte";
  import prepareAssets, { fetchFont } from "./utils/prepareAssets.js";
  import {
    readAsArrayBuffer,
    readAsImage,
    readAsPDF,
    readAsDataURL
  } from "./utils/asyncReader.js";
  import { ggID } from "./utils/helper.js";
  import { save } from "./utils/PDF.js";
  const genID = ggID();
  let pdfFile;
  let pdfName = "";
  let pages = [];
  let pagesScale = [];
  let allObjects = [];
  let currentFont = "Times-Roman";
  let focusId = null;
  let selectedPageIndex = -1;
  let saving = false;
  let addingDrawing = false;
  // for test purpose
  onMount(async () => {
    try {
      const res = await fetch("/public/pdfblank.pdf");
      const pdfBlob = await res.blob();
      await addPDF(pdfBlob);
      selectedPageIndex = 0;
      setTimeout(() => {
        fetchFont(currentFont);
        prepareAssets();
      }, 5000);
      // const imgBlob = await (await fetch("/test.jpg")).blob();
      // addImage(imgBlob);
      // addTextField("測試!");
      // addDrawing(200, 100, "M30,30 L100,50 L50,70", 0.5);
    } catch (e) {
      console.log(e);
    }
  });
  async function onUploadPDF(e) {

    console.log("onUploadPDF");
    console.log(e);
    const files = e.target.files || (e.dataTransfer && e.dataTransfer.files);
    console.log("FILES");
    console.log(files);
    const file = files[0] || files['new_file'];
    console.log("FILE");
    console.log(file);
    if (!file || file.type !== "application/pdf") return;
    selectedPageIndex = -1;
    try {
      console.log("AddingPDF");
      await addPDF(file);
      selectedPageIndex = 0;
    } catch (e) {
      console.log("Error");
      console.log(e);
    }
  }
  async function addPDF(file) {
    try {
      const pdf = await readAsPDF(file);
      pdfName = file.name;
      pdfFile = file;
      const numPages = pdf.numPages;
      pages = Array(numPages)
        .fill()
        .map((_, i) => pdf.getPage(i + 1));
      allObjects = pages.map(() => []);
      pagesScale = Array(numPages).fill(1);
    } catch (e) {
      console.log("Failed to add pdf.");
      throw e;
    }
  }
  async function onUploadImage(e) {
    const file = e.target.files[0];
    if (file && selectedPageIndex >= 0) {
      addImage(file);
    }
    e.target.value = null;
  }
  async function addImage(file) {
    try {
      // get dataURL to prevent canvas from tainted
      const url = await readAsDataURL(file);
      const img = await readAsImage(url);
      const id = genID();
      const { width, height } = img;
      const object = {
        id,
        type: "image",
        width,
        height,
        x: 0,
        y: 0,
        payload: img,
        file
      };
      allObjects = allObjects.map((objects, pIndex) =>
        pIndex === selectedPageIndex ? [...objects, object] : objects
      );
    } catch (e) {
      console.log(`Fail to add image.`, e);
    }
  }
  function onAddTextField() {
    if (selectedPageIndex >= 0) {
      addTextField();
    }
  }
  function addTextField(text = "New Text Field") {


    var sizex = document.getElementById("sizex").value;
    var familyx = document.getElementById("familyx").value;
    colortt = document.getElementById("colorx").value;

	//alert(sizex);
	//alert(familyx);
	//alert(colortt);

    var isbold = "normal";
    var isitalic = "normal";
    var idunderline = "unset";
    if (document.getElementById("boldx").className.indexOf("active") !== -1)   { isbold = "bold"; }
    if (document.getElementById("italicx").className.indexOf("active") !== -1)   { isitalic = "italic"; }
    //if (document.getElementById("underlinex").className.indexOf("active") !== -1)   { idunderline = "underline"; }

	//alert(isbold);


    const id = genID();
    //fetchFont(currentFont);
    const object = {
      id,
      text,
      type: "text",
      size: sizex,
      color: colortt,
      bold: isbold,
      italic: isitalic,
      underline: idunderline,
      width: 0, // recalculate after editing
      lineHeight: 1.8,
      fontFamily: familyx,
      x: 20,
      y: 20
    };
    allObjects = allObjects.map((objects, pIndex) =>
      pIndex === selectedPageIndex ? [...objects, object] : objects
    );
  }
  function onAddDrawing() {
    if (selectedPageIndex >= 0) {
      addingDrawing = true;
    }
  }
  function addDrawing(originWidth, originHeight, path, scale = 1) {
    const id = genID();
    const object = {
      id,
      path,
      type: "drawing",
      x: 0,
      y: 0,
      originWidth,
      originHeight,
      width: originWidth * scale,
      scale
    };
    allObjects = allObjects.map((objects, pIndex) =>
      pIndex === selectedPageIndex ? [...objects, object] : objects
    );
  }
  function selectFontFamily(event) {
    const name = event.detail.name;
    fetchFont(name);
    currentFont = name;
  }
  function selectPage(index) {
    selectedPageIndex = index;
  }
  function updateObject(objectId, payload) {
    allObjects = allObjects.map((objects, pIndex) =>
      pIndex == selectedPageIndex
        ? objects.map(object =>
            object.id === objectId ? { ...object, ...payload } : object
          )
        : objects
    );
  }
  function deleteObject(objectId) {
    allObjects = allObjects.map((objects, pIndex) =>
      pIndex == selectedPageIndex
        ? objects.filter(object => object.id !== objectId)
        : objects
    );
  }
  function onMeasure(scale, i) {
    pagesScale[i] = scale;
  }
  // FIXME: Should wait all objects finish their async work
  async function savePDF() {
    if (!pdfFile || saving || !pages.length) return;
    saving = true;
    try {
      await save(pdfFile, allObjects, pdfName, pagesScale);
    } catch (e) {
      console.log(e);
    } finally {
      saving = false;
    }
  }


  async function onAddWhiteout(e) {
    const file = "/public/borrado.png";
    if ( selectedPageIndex >= 0) {
      addImageUrlix(file);
    }
    e.target.value = null;
  }
  async function addImageUrlix(urlx) {
    try {
      // get dataURL to prevent canvas from tainted
      let response = await fetch(urlx);
      let data = await response.blob();
      let metadata = {
        type: 'image/png'
      };
      let file = new File([data], "/public/whiteout.png", metadata);

      const url = await readAsDataURL(file);
      const img = await readAsImage(url);
      const id = genID();
      const { width, height } = img;
      const object = {
        id,
        type: "image",
        width,
        height,
        x: 0,
        y: 0,
        payload: img,
        file
      };
      allObjects = allObjects.map((objects, pIndex) =>
        pIndex === selectedPageIndex ? [...objects, object] : objects
      );
    } catch (e) {
      console.log(`Fail to add image.`, e);
    }
  }


</script>

<svelte:window
  on:dragenter|preventDefault
  on:dragover|preventDefault
  on:drop|preventDefault={onUploadPDF} />
<Tailwind />
<div style="position: fixed; z-index: 10; text-align: center; width: 100%; height: 60px; color: #fff; background: #0067b8!important; ">
<h1 style="font-size: 22px; margin-top: 2px;"></h1>

<a id="homey" class="w-30 bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3 md:px-4 mr-3 md:mr-4 rounded" style="display: none; margin: 3px 0px 0px 10px;float: left;" href="https://www.offidocs.com">OffiDocs</a>
<a id="pdftoolsy" class="w-30 bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3 md:px-4 mr-3 md:mr-4 rounded" style="display: none; margin: 3px 10px 0px 0px; float: right;" href="https://pdf.offidocs.com">PDF Tools</a>

</div>


<main class="flex flex-col items-center py-16 bg-gray-100 min-h-screen" style="background-color: #c1d8f0;">
  <div style="margin-top: 40px; height: 70px; "
    class="fixed z-10 top-0 left-0 right-0 h-12 flex justify-center items-center
    bg-gray-200 border-b border-gray-300">
	<script> 
function gotohome() { 
		window.open("https://www.offidocs.com/"); 
}


function onLoadURLPress(urlname) {
        //alert("onLoadURLPress " + urlname );
        var filenamex = Math.floor(Math.random() * 2000000);
        filenamex = filenamex + ".pdf";
        var oReq = new XMLHttpRequest();
        var ooo = "https://www.offidocs.com/media/system/app/download.php?fileurl="+ encodeURIComponent(urlname)+"&filename="+ filenamex;
        console.log(ooo);
        oReq.open("GET", ooo, true);
        oReq.responseType = "arraybuffer";

        oReq.onload = function (oEvent) {

                if ( oReq.status != 200 )
                {
                        console.log("Error");
                        return;
                }
                var arrayBuffer = oReq.response; // Note: not oReq.responseText
                var new_file;
                new_file = new File([arrayBuffer], filenamex, {type: "application/pdf"});
                console.log("OK");

                console.log(new_file);

                var type = "drop";
                var event = new CustomEvent("CustomEvent")
                event.initCustomEvent(type, true, true, null)
                //event.dataTransfer.files[0] = new_file;

		var files = [];
		files[0] = new_file;

                event.dataTransfer = {
                        files
                }

                console.log(event);
                console.log("fire event YYY");
                var node = window;

                if (node.dispatchEvent) {
                        node.dispatchEvent(event)
                }
                if (node.fireEvent) {
                        node.fireEvent("on" + type, event)
                }
        };

        try {
                oReq.send(null);
        } catch(err) {
                console.log("Error 2");
        }


	document.getElementById("homey").style.display = "block";
	document.getElementById("pdftoolsy").style.display = "block";
}

setTimeout(function(){
        var pdfurl = $_GET('pdfurl');
        if ( pdfurl !== null ) {
                onLoadURLPress(pdfurl);
        }

        //try {
	//	var userxxx = $_GET('v');
	//	if ( userxxx == null ) {
	//		(stpdwrapper = window.stpdwrapper || []).push({});
	//	}
	//} catch(err) {}

	console.log("adxxxx");
}, 100);

function $_GET(param) {
        var vars = {};
        window.location.href.replace( location.hash, '' ).replace(
                /[?&]+([^=&]+)=?([^&]*)?/gi, // regexp
                function( m, key, value ) { // callback
                        vars[key] = value !== undefined ? value : '';
                }
        );

        if ( param ) {
                return vars[param] ? vars[param] : null;
        }
        return vars;
}

</script>



    <input
      type="file"
      name="pdf"
      id="pdf"
      on:change={onUploadPDF}
      class="hidden" />
    <input
      type="file"
      id="image"
      name="image"
      class="hidden"
      on:change={onUploadImage} />
    <label
      class="whitespace-no-wrap bg-blue-500 hover:bg-blue-700 text-white
      font-bold py-1 px-3 md:px-4 rounded mr-3 cursor-pointer md:mr-4"
      for="pdf">
      Upload PDF
    </label>
    <div style="height: 70px; margin-top: 2px; background-color: #edf2f7;"
      class="relative mr-4 flex h-8 bg-gray-400 rounded-sm overflow-hidden
      md:mr-5">
      <label style="height: 64px; width: 64px;" 
        class="flex items-center justify-center h-full w-8 hover:bg-gray-500
        cursor-pointer"
        for="image"
        class:cursor-not-allowed={selectedPageIndex < 0}
        class:bg-gray-500={selectedPageIndex < 0}>
        <img src="/public/addimage.png?v=01" alt="An icon for adding images" />
      </label>
      <label style="height: 64px; width: 64px;"
        class="flex items-center justify-center h-full w-8 hover:bg-gray-500
        cursor-pointer"
        for="text"
        class:cursor-not-allowed={selectedPageIndex < 0}
        class:bg-gray-500={selectedPageIndex < 0}
        on:click={onAddTextField}>
        <img src="/public/addtext.png?v=01" alt="An icon for adding text" />
      </label>
      <label style="height: 64px; width: 64px;"
        class="flex items-center justify-center h-full w-8 hover:bg-gray-500
        cursor-pointer"
	for="draw"
        on:click={onAddDrawing}
        class:cursor-not-allowed={selectedPageIndex < 0}
        class:bg-gray-500={selectedPageIndex < 0}>
        <img src="/public/adddraw.png?v=01" alt="An icon for adding drawing" />
      </label>
      <label style="height: 64px; width: 64px;"
        class="flex items-center justify-center h-full w-8 hover:bg-gray-500
        cursor-pointer"
	for="whiteout"
        on:click={onAddWhiteout}
        class:cursor-not-allowed={selectedPageIndex < 0}
        class:bg-gray-500={selectedPageIndex < 0}>
        <img src="/public/whiteout.png?v=01" alt="An icon for removing" />
      </label> 
    </div>
    <div style="max-width: 180px;" class="justify-center mr-3 md:mr-4 w-full max-w-xs hidden md:flex">
      <img src="/public/edit.svg" class="mr-2" alt="a pen, edit pdf name" />
      <input
        placeholder="Rename PDF"
        type="text"
        class="flex-grow bg-transparent"
        bind:value={pdfName} />
    </div>
    <button
      on:click={savePDF}
      class="w-20 bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3
      md:px-4 mr-3 md:mr-4 rounded"
      class:cursor-not-allowed={pages.length === 0 || saving || !pdfFile}
      class:bg-blue-700={pages.length === 0 || saving || !pdfFile}>
      {saving ? 'Saving' : 'Save'}
    </button>
  </div>

<style>
.btm-navbar-container .settings-container {
    padding: 0 0 0 20px;
    border-left: 2px solid #d0d0d0;
    height: 45px;
}
.pull-left {
    float: left;
}
.btm-navbar-container {
    height: 55px;
    padding: 5px 10px;
    background: #f9fafb;
    border-color: rgba(34,36,38,.15);
    -webkit-box-shadow: 0 2px 25px 0 rgb(34 36 38 / 5%) inset;
    box-shadow: 0 2px 25px 0 rgb(34 36 38 / 5%) inset;
    vertical-align: middle;
    line-height: 44px;
}

@media only screen and (min-width: 1200px) {
.ui.container {
    width: 100%!important;
}
}

@media only screen and (min-width: 1200px)  {
.ui.container {
    width: 1127px;
    margin-left: auto!important;
    margin-right: auto!important;
}
}

.ui.container {
    display: block;
    max-width: 100%!important;
}

.btm-navbar-container .setting-group {
    float: left;
    margin-right: 10px;
}


.btm-navbar-container .settings-container {
    padding: 0 0 0 20px;
    border-left: 2px solid #d0d0d0;
    height: 45px;
}

.pull-left {
    float: left;
}
.btm-navbar-container .setting-margin.choice-margin {
    margin-top: 3px;
}
.btm-navbar-container .setting-margin {
    margin-right: 5px;
}
.ui.fluid.dropdown {
    display: block;
    width: 100%;
    min-width: 0;
}

.ui.selection.dropdown {
    cursor: pointer;
    word-wrap: break-word;
    line-height: 1em;
    white-space: normal;
    outline: 0;
    transform: rotateZ(0);
    min-width: 14em;
    min-height: 2.71428571em;
    background: #fff;
    display: inline-block;
    padding: 0.78571429em 2.1em 0.78571429em 1em;
    color: rgba(0,0,0,.87);
    box-shadow: none;
    border: 1px solid rgba(34,36,38,.15);
    border-radius: 0.28571429rem;
    transition: box-shadow .1s ease,width .1s ease;
}

.ui.dropdown {
    cursor: pointer;
    position: relative;
    display: inline-block;
    outline: 0;
    text-align: left;
    transition: box-shadow .1s ease,width .1s ease;
    -webkit-tap-highlight-color: transparent;
}

.helvetica {
    font-family: Helvetica,helvetica neue,Arial,sans-serif;
}


.ui.dropdown>.text {
    display: inline-block;
    transition: none;
}

.ui.fluid.dropdown>.dropdown.icon {
    float: right;
}

.ui.selection.dropdown>.delete.icon, .ui.selection.dropdown>.dropdown.icon, .ui.selection.dropdown>.search.icon {
    cursor: pointer;
    position: absolute;
    width: auto;
    height: auto;
    line-height: 1.21428571em;
    top: 0.78571429em;
    right: 1em;
    z-index: 3;
    margin: -0.78571429em;
    padding: 0.91666667em;
    opacity: .8;
    transition: opacity .1s ease;
}

.ui.dropdown>.dropdown.icon {
    font-family: Dropdown;
    line-height: 1;
    height: 1em;
    width: 1.23em;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    font-weight: 400;
    font-style: normal;
    text-align: center;
}


.ui.dropdown>.dropdown.icon {
    position: relative;
    width: auto;
    font-size: .85714286em;
    margin: 0 0 0 1em;
}

i.icon, i.icons {
    font-size: 1em;
}


i.icon {
    display: inline-block;
    opacity: 1;
    margin: 0 0.25rem 0 0;
    width: 1.18em;
    height: 1em;
    font-family: Icons;
    font-style: normal;
    font-weight: 400;
    text-decoration: inherit;
    text-align: center;
    speak: none;
    font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
}

@media only screen and (min-width: 992px) {
.ui.selection.dropdown .menu {
    max-height: 16.02857143rem;
}
}

@media only screen and (min-width: 768px) {
.ui.selection.dropdown .menu {
    max-height: 10.68571429rem;
} }

.ui.selection.dropdown .menu {
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-overflow-scrolling: touch;
    border-top-width: 0!important;
    width: auto;
    outline: 0;
    margin: 0 -1px;
    min-width: calc(100% + 2px);
    width: calc(100% + 2px);
    border-radius: 0 0 0.28571429rem 0.28571429rem;
    box-shadow: 0 2px 3px 0 rgb(34 36 38 / 15%);
    transition: opacity .1s ease;
}

.ui.dropdown .menu {
    left: 0;
}

.ui.dropdown .menu {
    cursor: auto;
    position: absolute;
    display: none;
    outline: 0;
    top: 100%;
    min-width: -webkit-max-content;
    min-width: -moz-max-content;
    min-width: max-content;
    margin: 0;
    padding: 0 0;
    background: #fff;
    font-size: 1em;
    text-shadow: none;
    text-align: left;
    box-shadow: 0 2px 3px 0 rgb(34 36 38 / 15%);
    border: 1px solid rgba(34,36,38,.15);
    border-radius: 0.28571429rem;
    transition: opacity .1s ease;
    z-index: 11;
    will-change: transform,opacity;
}

.transition {
    -webkit-animation-iteration-count: 1;
    animation-iteration-count: 1;
    -webkit-animation-duration: .3s;
    animation-duration: .3s;
    -webkit-animation-timing-function: ease;
    animation-timing-function: ease;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
}

.ui.dropdown .menu .selected.item, .ui.dropdown.selected {
    background: rgba(0,0,0,.03);
    color: rgba(0,0,0,.95);
}
.ui.dropdown .menu .active.item {
    background: 0 0;
    font-weight: 700;
    color: rgba(0,0,0,.95);
    box-shadow: none;
    z-index: 12;
}
.ui.selection.dropdown .menu>.item {
    border-top: 1px solid #fafafa;
    padding: 0.78571429rem 1.14285714rem!important;
    white-space: normal;
    word-wrap: normal;
}
.ui.dropdown .menu>.item:first-child {
    border-top-width: 0;
}
.ui.dropdown .menu>.item {
    position: relative;
    cursor: pointer;
    display: block;
    border: none;
    height: auto;
    text-align: left;
    border-top: none;
    line-height: 1em;
    color: rgba(0,0,0,.87);
    padding: 0.78571429rem 1.14285714rem!important;
    font-size: 1rem;
    text-transform: none;
    font-weight: 400;
    box-shadow: none;
    -webkit-touch-callout: none;
}
.ui.dropdown .menu>* {
    white-space: nowrap;
}

.swatch-picker {
    padding: 8px;
    background: #fff;
    display: inline-block;
    cursor: pointer;
    height: 38px;
    box-shadow: none;
    border: 1px solid rgba(34,36,38,.15);
    border-radius: 0.28571429rem;
    transition: box-shadow .1s ease,width .1s ease;
}

.swatch-picker .color-picker {
    width: 20px;
    height: 100%;
    border: 1px solid rgba(34,36,38,.15);
    border-radius: 0.28571429rem;
    transition: box-shadow .1s ease,width .1s ease;
}

.ui.buttons:not(.basic):not(.inverted) {
    box-shadow: none;
}

.btm-navbar-container .setting-group.ui.buttons {
    margin-top: 6px;
    margin-right: 5px;
}
.ui.buttons {
    display: inline-flex;
    flex-direction: row;
    font-size: 0;
    vertical-align: baseline;
    margin: 0 0.25em 0 0;
}

.ui.buttons:not(.basic):not(.inverted)>.button, .ui.buttons>.ui.button:not(.basic):not(.inverted) {
    box-shadow: 0 0 0 1px transparent inset, 0 0 0 0 rgb(34 36 38 / 15%) inset;
}

.btm-navbar-container .setting-group .ui.icon.button {
    font-size: 1.2rem;
    padding: 0.5em;
}
.ui.buttons .button:first-child {
    border-left: none;
    margin-left: 0;
    border-top-left-radius: 0.28571429rem;
    border-bottom-left-radius: 0.28571429rem;
}
.ui.buttons .button {
    flex: 1 0 auto;
    margin: 0;
    border-radius: 0;
    margin: 0;
}
.ui.icon.button, .ui.icon.buttons .button {
    padding: 0.78571429em 0.78571429em 0.78571429em;
}
.ui.button, .ui.buttons .button, .ui.buttons .or {
    font-size: 1rem;
}
.ui.button {
    cursor: pointer;
    display: inline-block;
    min-height: 1em;
    outline: 0;
    border: none;
    vertical-align: baseline;
    background: #e0e1e2 none;
    color: rgba(0,0,0,.6);
    font-family: Lato,'Helvetica Neue',Arial,Helvetica,sans-serif;
    margin: 0 0.25em 0 0;
    padding: 0.78571429em 1.5em 0.78571429em;
    text-transform: none;
    text-shadow: none;
    font-weight: 700;
    line-height: 1em;
    font-style: normal;
    text-align: center;
    text-decoration: none;
    border-radius: 0.28571429rem;
    box-shadow: 0 0 0 1px transparent inset, 0 0 0 0 rgb(34 36 38 / 15%) inset;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    transition: opacity .1s ease,background-color .1s ease,color .1s ease,box-shadow .1s ease,background .1s ease;
    will-change: '';
    -webkit-tap-highlight-color: transparent;
}
[type=reset], [type=submit], button, html [type=button] {
    -webkit-appearance: button;
}

.btm-navbar-container .ui.icon.button>.icon {
    padding: 0;
}

.ui.icon.button>.icon, .ui.icon.buttons .button>.icon {
    opacity: .9;
    margin: 0!important;
    vertical-align: top;
}
.ui.button>.icon:not(.button) {
    height: 0.85714286em;
    opacity: .8;
    margin: 0 0.42857143em 0 -0.21428571em;
    transition: opacity .1s ease;
    vertical-align: '';
    color: '';
}



.custom-select {
  position: relative;
  font-family: Arial;
}

.custom-select select {
   height: 30px;
}

.select-selected {
  background-color: #c6c3c3;
}

/* Style the arrow inside the select element: */
.select-selected:after {
  position: absolute;
  content: "";
  top: 14px;
  right: 10px;
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-color: #fff transparent transparent transparent;
}

/* Point the arrow upwards when the select box is open (active): */
.select-selected.select-arrow-active:after {
  border-color: transparent transparent #fff transparent;
  top: 7px;
}

/* style the items (options), including the selected item: */
.select-items div,.select-selected {
  color: #ffffff;
  padding: 8px 16px;
  border: 1px solid transparent;
  border-color: transparent transparent rgba(0, 0, 0, 0.1) transparent;
  cursor: pointer;
}

/* Style items (options): */
.select-items {
  position: absolute;
  background-color: #c6c3c3;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 99;
}

/* Hide the items when the select box is closed: */
.select-hide {
  display: none;
}

.select-items div:hover, .same-as-selected {
  background-color: rgba(0, 0, 0, 0.1);
}


</style>

<script>


var x, i, j, l, ll, selElmnt, a, b, c;
/* Look for any elements with the class "custom-select": */
x = document.getElementsByClassName("custom-select");
l = x.length;
for (i = 0; i < l; i++) {
  selElmnt = x[i].getElementsByTagName("select")[0];
  ll = selElmnt.length;
  /* For each element, create a new DIV that will act as the selected item: */
  a = document.createElement("DIV");
  a.setAttribute("class", "select-selected");
  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  x[i].appendChild(a);
  /* For each element, create a new DIV that will contain the option list: */
  b = document.createElement("DIV");
  b.setAttribute("class", "select-items select-hide");
  for (j = 1; j < ll; j++) {
    /* For each option in the original select element,
    create a new DIV that will act as an option item: */
    c = document.createElement("DIV");
    c.innerHTML = selElmnt.options[j].innerHTML;
    c.addEventListener("click", function(e) {
        /* When an item is clicked, update the original select box,
        and the selected item: */
        var y, i, k, s, h, sl, yl;
        s = this.parentNode.parentNode.getElementsByTagName("select")[0];
        sl = s.length;
        h = this.parentNode.previousSibling;
        for (i = 0; i < sl; i++) {
          if (s.options[i].innerHTML == this.innerHTML) {
            s.selectedIndex = i;
            h.innerHTML = this.innerHTML;
            y = this.parentNode.getElementsByClassName("same-as-selected");
            yl = y.length;
            for (k = 0; k < yl; k++) {
              y[k].removeAttribute("class");
            }
            this.setAttribute("class", "same-as-selected");
            break;
          }
        }
        h.click();
    });
    b.appendChild(c);
  }
  x[i].appendChild(b);
  a.addEventListener("click", function(e) {
    /* When the select box is clicked, close any other select boxes,
    and open/close the current select box: */
    e.stopPropagation();
    closeAllSelect(this);
    this.nextSibling.classList.toggle("select-hide");
    this.classList.toggle("select-arrow-active");
  });
}

function closeAllSelect(elmnt) {
  /* A function that will close all select boxes in the document,
  except the current select box: */
  var x, y, i, xl, yl, arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  xl = x.length;
  yl = y.length;
  for (i = 0; i < yl; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i)
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < xl; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("select-hide");
    }
  }
}

/* If the user clicks anywhere outside the select box,
then close all select boxes: */
document.addEventListener("click", closeAllSelect);


</script>

<div style="position: fixed;     z-index: 10;  margin-top: 40px;" class="ui container btm-navbar-container">
  <div class="pull-left settings-container">
	<div>
		<div class="setting-margin pull-left choice-margin">
			<div class="custom-select" style="width:150px;">
                                <select id="familyx">
                                        <option value="Helvetica">Font-family:</option>
                                        <option value="Helvetica">Helvetica</option>
                                        <option value="Times-Roman">Times-Roman</option>
                                        <option value="Courier">Courier</option>

                                </select>
                        </div>
		</div>
		<div class="setting-margin pull-left choice-margin">
			<div class="custom-select" style="width:100px;">
  				<select id="sizex">
    					<option value="13">Font-size:</option>
    					<option value="8">8</option><option value="9">9</option>
					<option value="10">10</option><option value="11">11</option>
					<option value="12">12</option><option value="13">13</option>
                                        <option value="14">14</option><option value="15">15</option>
                                        <option value="16">16</option><option value="17">17</option>
                                        <option value="18">18</option><option value="19">19</option>
                                        <option value="20">20</option><option value="21">21</option>
                                        <option value="24">24</option><option value="25">25</option>
                                        <option value="28">28</option><option value="29">29</option>
                                        <option value="32">32</option><option value="36">36</option>
                                        <option value="40">40</option><option value="50">50</option>

  				</select>
			</div>
		</div>
		<div class="setting-margin pull-left choice-margin">
<script>

var colorPicker = document.getElementById("colorx");
colorPicker.addEventListener("change", watchColorPicker, false);

var colorxxy;

function watchColorPicker(event) {
  colorxxy = event.target.value;
  //alert(colorxxy);
}

</script>
		<div style="margin-top: 3px;">
    				<input type="color" id="colorx" name="head" style="width: 27px;"
           				value="#000000">
		</div>
	</div>
<style>

.button {
  border: none;
  outline: none;
  padding: 10px 16px;
  background-color: #f1f1f1;
  cursor: pointer;
}

.active, .button:hover {
  background-color: #666;
}

</style>
	<div id="myDIV" class="ui buttons setting-group setting-margin">
		<button id="boldx" class="ui icon button text-format-btn"><i aria-hidden="true" class="fas fa-bold"></i></button>
		<button id="italicx" class="ui icon button text-format-btn"><i aria-hidden="true" class="fas fa-italic"></i></button>
	<!--	<button id="underlinex" class="ui icon button text-format-btn"><i aria-hidden="true" class="fas fa-underline"></i></button>    -->
	     <!--   <button id="uip-select-btn" class="ui icon button text-format-btn" title="Open the Icon Library"><i aria-hidden="true" class="fas fa-laugh-wink"></i></button>  -->
            
	</div>
<script>

document.getElementById("boldx").addEventListener("click", function() {
    if (document.getElementById("boldx").className.indexOf("active") !== -1)
    {
	document.getElementById("boldx").className = document.getElementById("boldx").className.replace(" active", "");
    }
    else {
	document.getElementById("boldx").className += " active";
    }
  });

document.getElementById("italicx").addEventListener("click", function() {
    if (document.getElementById("italicx").className.indexOf("active") !== -1)
    {
        document.getElementById("italicx").className = document.getElementById("italicx").className.replace(" active", "");
    }
    else {
        document.getElementById("italicx").className += " active";
    }
  });


//document.getElementById("underlinex").addEventListener("click", function() {
 //   if (document.getElementById("underlinex").className.indexOf("active") !== -1)
//    {
 //       document.getElementById("underlinex").className = document.getElementById("underlinex").className.replace(" active", "");
//    }
//    else {
//        document.getElementById("underlinex").className += " active";
//    }
//  });

</script>

</div>
</div>
</div>

  {#if addingDrawing}
    <div
      transition:fly={{ y: -200, duration: 500 }}
      class="fixed z-10 top-0 left-0 right-0 border-b border-gray-300 bg-white
      shadow-lg"
      style="margin: 80px auto 0 auto; height: 50%; ">
      <p style="text-align: center;     margin-top: 10px; ">Draw any picture to load in the PDF</p>
      <DrawingCanvas
        on:finish={e => {
          const { originWidth, originHeight, path } = e.detail;
          let scale = 1;
          if (originWidth > 500) {
            scale = 500 / originWidth;
          }
          addDrawing(originWidth, originHeight, path, scale);
          addingDrawing = false;
        }}
        on:cancel={() => (addingDrawing = false)} />
    </div>
  {/if}
  {#if pages.length}
    <div class="flex justify-center px-5 w-full md:hidden">
      <img src="/public/edit.svg" class="mr-2" alt="a pen, edit pdf name" />
      <input
        placeholder="Rename your PDF here"
        type="text"
        class="flex-grow bg-transparent"
        bind:value={pdfName} />
    </div>
    <div class="w-full" style="margin-top: 100px;">
      {#each pages as page, pIndex (page)}
        <div
          class="p-5 w-full flex flex-col items-center overflow-hidden"
          on:mousedown={() => selectPage(pIndex)}
          on:touchstart={() => selectPage(pIndex)}>
          <div
            class="relative shadow-lg"
            class:shadow-outline={pIndex === selectedPageIndex}>
            <PDFPage
              on:measure={e => onMeasure(e.detail.scale, pIndex)}
              {page} />
            <div
              class="absolute top-0 left-0 transform origin-top-left"
              style="transform: scale({pagesScale[pIndex]}); touch-action: none;">
              {#each allObjects[pIndex] as object (object.id)}
                {#if object.type === 'image'}
                  <Image
                    on:update={e => updateObject(object.id, e.detail)}
                    on:delete={() => deleteObject(object.id)}
                    file={object.file}
                    payload={object.payload}
                    x={object.x}
                    y={object.y}
                    width={object.width}
                    height={object.height}
                    pageScale={pagesScale[pIndex]} />
                {:else if object.type === 'text'}
                  <Text
                    on:update={e => updateObject(object.id, e.detail)}
                    on:delete={() => deleteObject(object.id)}
                    on:selectFont={selectFontFamily}
                    text={object.text}
                    x={object.x}
                    y={object.y}
                    size={object.size}
		    color={object.color}
                    lineHeight={object.lineHeight}
                    fontFamily={object.fontFamily}
		    bold={object.bold}
		    italic={object.italic}
                    underline={object.underline}
                    pageScale={pagesScale[pIndex]} />
                {:else if object.type === 'drawing'}
                  <Drawing
                    on:update={e => updateObject(object.id, e.detail)}
                    on:delete={() => deleteObject(object.id)}
                    path={object.path}
                    x={object.x}
                    y={object.y}
                    width={object.width}
                    originWidth={object.originWidth}
                    originHeight={object.originHeight}
                    pageScale={pagesScale[pIndex]} />
                {/if}
              {/each}

            </div>
          </div>
        </div>
      {/each}
    </div>
  {:else}
    <div class="w-full flex-grow flex justify-center items-center">
      <span class=" font-bold text-3xl text-gray-500">Drag something here</span>
    </div>
  {/if}
</main>



<ins class="stpdwrapper"
    style="display:inline-block;"
    data-tag-id="7382"></ins>



